<template>
  <v-container fluid>
    <div class="modal-padding">
      <v-row>
        <v-col cols="12" sm="12" class="left--right-00">
          <div class="text-center">Assign Test for Verification</div>
          <div class="text-center text-bold">
            {{ testName }}
          </div>
        </v-col>
      </v-row>
      <v-row class="Schedule-block">
        <v-col cols="8" sm="8" class=""> </v-col>
        <v-col cols="2" sm="2" class="">
          <div class="text-center text-bold">
            Assigned On
          </div></v-col
        >
        <v-col cols="2" sm="2" class="">
          <div class="text-center text-bold">
            Approved On
          </div>
        </v-col>
      </v-row>
      <v-row class="Schedule-block assigning-list">
        <v-col cols="2" sm="2" class=""> </v-col>
        <v-col cols="6" sm="6" class="">Verified By </v-col>
        <v-col cols="2" sm="2" class=""> </v-col>
        <v-col cols="2" sm="2" class=""> </v-col>
        <v-row
          class="margin-0 subject-row"
          v-for="(sub, idx) in subjects"
          :key="idx"
        >
          <v-col cols="2" sm="2" class="sub-name">{{ sub.name }}: </v-col>
          <v-col cols="6" sm="6" class=""
            ><v-select
              v-model="sub.selectedTeacher"
              :items="sub.teachers"
			  @change="changeTeacher(sub)"
              label="Teacher"
              hide-details
              item-text="name"
              item-value="user_id"
              dense
              outlined
              class=""
            ></v-select>
          </v-col>
          <v-col cols="2" sm="2" class="text-center ">{{sub.assignedOn? computedDateFormattedMomentjs(sub.assignedOn): '-'}}</v-col>
          <v-col cols="2" sm="2" class="text-center ">-</v-col>
        </v-row>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12">
          <div class="right-align">
            <v-btn
              @click="assignTestCall"
              class="right-btn cust-btn"
              color="primary"
              >Assign</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";
export default {
  name: "AssignTest",
  props: ["onClose", "status", "data"],
  data() {
    return {
      mode: this.data.selectedTest ? this.data.selectedTest.visible : null,
      selectedTest: this.data.selectedTest,
      subjects: [],
      tableData: [],
      testName: this.data.selectedTest.test_name,
      loading: false,
    };
  },
  mounted() {
    this.initSubs();
  },
  methods: {
    ...mapActions({
      getSubjectUsers: "userStore/getSubjectUsers",
      assignTest: "testStore/assignTest",
      assignTestStatus: "testStore/assignTestStatus",
    }),

    assignTestCall() {
      let assignTest = [];
      this.subjects.map((x,index) => {
          if (x.id && x.selectedTeacher && x.assignedOn) {
            assignTest.push({ data_type_id: x.id, assigned_to: x.selectedTeacher,assigned_on: x.assignedOn })
            //return { data_type_id: x.id, assigned_to: x.selectedTeacher };
          } else if (x.id && x.selectedTeacher && !x.assignedOn) {
            assignTest.push({ data_type_id: x.id, assigned_to: x.selectedTeacher })
			  
		      }
          if(assignTest[index] && assignTest[index].data_type_id==constants.BIOLOGY_SUBJECT_ID){
             let sub = constants.BIOLOGY_SUBSUBJECTS.find(s=>s.title === x.name)
             if(sub && sub.code){
               assignTest[index].sub_subject = sub.code;
             }
           }
         
        })
      let postData = {
        test_id: this.selectedTest.id,
        assignment_data: assignTest ,
      };
      let me = this;
      if (!assignTest || !assignTest.length) {
        me.$toasted.error("Please assign a teacher to at least one subject.",{icon:'info'})
        return
      }
      if (assignTest.length !== this.subjects.length) {
        
        return me.onClose({ status: true, action: "yes",item:{postData,selectedTest:this.data.selectedTest},refId:this.data.refId});
      }
      this.$root.showLoader = true;

      this.assignTest(postData)
        .then((response) => {
          me.$root.showLoader = false;
          me.$toasted.success(response.message);
          me.onClose({ status: false, action: "reloadTestList" });
        })
        .catch((err) => {
          this.$toasted.error("Error assigning test to teachers.");
          this.$root.showLoader = false;
        });
    
    },
    getSubjectTeachers(subjectIds) {
      let postData = {
        subject_id: subjectIds,
        role_id: this.roleIds.TR,
      };
      let me = this;
      this.$root.showLoader = true;
      this.getSubjectUsers(postData)
        .then((response) => {
          me.$root.showLoader = false;
          me.subjects.forEach((sub) => {
            sub.teachers = response[sub.id]; 
          });
          this.getAssignTestStatus();
        })
        .catch((err) => {
          me.$toasted.error("Error getting subject teachers.");
          me.$root.showLoader = false;
        });
    },
    initSubs() {
      this.subjects = [];
      this.selectedTest = this.data.selectedTest;
      this.testName = this.data.selectedTest.test_name;
      let subj = this.selectedTest.subjects.split(",");
      let subjIds = this.selectedTest.subject_ids.split(",");
      subj.forEach((sub, idx) => {
        let obj = {
          name: sub.trim(),
          id: subjIds[idx].trim(),
          teachers: [],
        };
        this.subjects.push(obj);
      });
      this.getSubjectTeachers(subjIds);
    },

    computedDateFormattedMomentjs(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    },
    getAssignTestStatus() {
      let getData = {
        testId: this.selectedTest.id,
      };
      let me = this;
      this.$root.showLoader = true;
      this.assignTestStatus(getData)
        .then((response) => {
          me.$root.showLoader = false;
          me.tableData = response;
           me.subjects.forEach((i) => {
              var result = me.tableData.find(obj => {
                return obj.subject_id == i.id
              })
             if (result) {
               i.selectedTeacher = result.assigned_to; 
			   i.assignedOn= result.created_at || null;    
            }
          });
          this.$forceUpdate();

        })
        .catch((err) => {
          me.$toasted.error("Error getting approval status.");
          me.$root.showLoader = false;
        });
        
        
    },
	changeTeacher(item){
		let index = this.subjects.findIndex(d=>d.id==item.id)
			if (index>-1) {
				this.subjects[index].assignedOn = null;
			}
		this.$forceUpdate()
	}
  },
  watch: {
    status(val) {
      if (val) this.initSubs();
      this.$forceUpdate();
    },
  },
  computed: {
    ...mapState("userStore", ["user"]),
  },
};
</script>
